import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(theme => ({
  black: {
    color: theme.palette.common.gray600,
    fontFamily: theme.typography.body2.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
  },
  value: {
    color: theme.palette.common.gray800,
    fontFamily: theme.typography.body2.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
  },
  grayInput: {
    backgroundColor: theme.palette.common.gray100,
    borderColor: theme.palette.common.gray400,
  },
  /* eslint-disable sort-keys-fix/sort-keys-fix */
  calendar: {
    '& .react-calendar__tile': {
      color: theme.palette.common.gray800,
      fontFamily: theme.typography.body2.fontFamily,
      fontSize: theme.typography.h4.fontSize,
    },

    '& .react-calendar__decade-view__years__year.react-calendar__tile': {
      padding: 0,
    },
    '& .react-calendar__month-view__days__day--weekend': {
      color: theme.palette.common.gray800,
    },
    '& .react-calendar__month-view__days__day--neighboringMonth': {
      color: theme.palette.common.gray600,
    },
    '& .react-calendar__month-view__days__day.react-calendar__tile': {
      '&:hover': {
        borderRadius: '50%',
      },
      borderRadius: '50%',
      height: theme.spacing(5.5),
      width: theme.spacing(5),
    },
    '& .react-calendar__month-view__weekdays__weekday': {
      borderBottom: theme.customBorders.gray300,
      fontWeight: 400,
      marginBottom: theme.spacing(1),
      textTransform: 'none',
    },
    '& .react-calendar__month-view__weekdays__weekday abbr': {
      color: theme.palette.common.gray500,
      fontFamily: theme.typography.body2.fontFamily,
      fontSize: theme.typography.overline.fontSize,
      fontWeight: 400,
      textDecoration: 'none',
    },
    '& .react-calendar__navigation button:focus': {
      backgroundColor: 'unset',
    },
    '& .react-calendar__navigation button:focus-visible': {
      outline: 'revert',
    },
    '& .react-calendar__navigation button:enabled': {
      borderRadius: theme.misc.borderRadius,
      '&:hover': {
        backgroundColor: theme.palette.common.gray100,
      },
    },
    '& .react-calendar__navigation button:disabled': {
      borderRadius: theme.misc.borderRadius,
    },
    '& .react-calendar__navigation__label': {
      fontFamily: theme.typography.body2.fontFamily,
      fontSize: theme.typography.h3.fontSize,
    },
    '& .react-calendar__tile--active': {
      backgroundColor: theme.palette.common.blue400,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.common.blue600,
      },
    },
    '& .react-calendar__tile--hasActive': {
      backgroundColor: theme.palette.common.blue400,
      borderRadius: theme.misc.borderRadius,
      color: theme.palette.common.white,
    },
    '& .react-calendar__tile:disabled': {
      '&:hover': {
        backgroundColor: 'unset',
      },
      backgroundColor: 'unset',
      color: theme.palette.common.gray400,
    },
    '& .react-calendar__tile:hover': {
      backgroundColor: theme.palette.common.gray100,
      borderRadius: theme.misc.borderRadius,
    },
    '& .react-calendar__year-view .react-calendar__tile': {
      padding: 0,
    },
    '&.react-calendar': {
      zIndex: theme.zIndex.dropdownMenu,
    },
    border: theme.customBorders.gray300,
    borderRadius: theme.misc.borderRadius,
    boxShadow: theme.customShadows.shadow4,
    minWidth: theme.spacing(39.25),
    padding: theme.spacing(2),
    transition: 'opacity 0.3s ease, visibility 0.3s ease',
    zIndex: 1,
  },
  /* eslint-enable sort-keys-fix/sort-keys-fix */
  calendarContainer: {
    zIndex: theme.zIndex.modal,
  },
  calendarTile: {
    height: theme.spacing(6),
    width: theme.spacing(9),
  },
  clearButton: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  dayContainer: {
    '&.active': {
      border: theme.customBorders.primary,
    },
    '&.error': {
      border: theme.customBorders.error,
    },
    border: theme.customBorders.gray400,
    borderRadius: theme.misc.borderRadius,
    boxShadow: theme.customShadows.selectDropdown,
    cursor: 'pointer',
    height: theme.spacing(5),
    padding: theme.spacing(0.875, 2),

    transition: 'border-color 0.3s ease',
  },
  errorMessage: {
    bottom: theme.spacing(-3),
    position: 'absolute',
    width: '100%',
  },
  icon: {
    transition: 'color 0.3s ease',
    width: theme.spacing(2),
  },
  leftArrow: {
    transform: 'rotate(180deg)',
  },
  root: {
    '& .MuiIconButton-root': {
      width: theme.spacing(5),
    },
    backgroundColor: theme.palette.common.white,
    display: 'inline-block',
    position: 'relative',
    width: '100%',
  },
}));

export default useStyles;
